import { useContext } from 'react'
import { SurveyQuestionsContext } from 'contexts'

// Provides the current community context
function useSurveyQuestions() {
  return useContext(SurveyQuestionsContext)
}

export default useSurveyQuestions
